import {
  collection,
  doc,
} from 'firebase/firestore';

import {
  db,
} from '@/services/firebase.js';

import {
  converters,
} from '../converters/index.js';

export const hook_content_refs = {
  document: ({
    workspace_id,
    project_id,
    hook_content_id,
  }) => {
    const path = [
      'workspaces',
      workspace_id,
      'projects',
      project_id,
      'hook_contents',
      hook_content_id,
    ].join('/');
    return doc(db, path).withConverter(converters.hook_contents);
  },
  collection: ({
    workspace_id,
    project_id,
  }) => {
    const path = [
      'workspaces',
      workspace_id,
      'projects',
      project_id,
      'hook_contents',
    ].join('/');
    return collection(db, path).withConverter(converters.hook_contents);
  },
};


